import {TextArea} from '@/components/commons/textarea/TextArea'
import {useTranslation} from '@/translations/i18n'
import {useFormContext} from 'react-hook-form'
import {PatientNotesFormValidationSchema} from '@/features/patients/types'

export const PatientNotesForm = () => {
    const {t} = useTranslation()

    // methods
    const form = useFormContext<PatientNotesFormValidationSchema>()

    return <TextArea placeholder={t('commons:notes_placeholder')} {...form.register('notes')} />
}
